import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Container, Pagination, Paper, TextField, Typography, } from "@mui/material";
import { useState } from "react";
import { useSearchTeams } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { TransferRequestButton } from "../transfer/TransferRequestButton";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { TeamSearchResultView } from "./TeamSearchResultView";
export const SearchTeamResults = ({ onCreateTeam, } = {}) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [activeSearch, setActiveSearch] = useState("");
    const [page, setPage] = useState(1);
    const { data, isLoading, isError } = useSearchTeams({
        searchTerm: activeSearch,
        page,
    });
    const handleSearch = () => {
        setActiveSearch(searchTerm);
        setPage(1);
    };
    const handlePageChange = (_event, value) => setPage(value);
    const renderResults = () => {
        if (isLoading) {
            return _jsx(Loading, {});
        }
        if (!data) {
            return _jsx(ErrorView, {});
        }
        if (data.count === 0) {
            if (!activeSearch) {
                return (_jsx(Typography, { color: "text.secondary", children: "Search for your team above to request a transfer." }));
            }
            return (_jsxs(Box, { children: [_jsxs(Typography, { color: "text.secondary", children: ["No teams found for \u201C", activeSearch, "\u201D."] }), onCreateTeam && (_jsxs(Box, { sx: { mt: 1 }, children: [_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 1 }, children: "Can't find your team? Create it and invite your teammates." }), _jsx(Button, { variant: "outlined", onClick: onCreateTeam, children: "Create a team" })] }))] }));
        }
        return (_jsxs(Paper, { children: [data.results.map((teamSearchResult, index) => (_jsxs(Box, { display: "flex", alignItems: "center", gap: 2, padding: 2, bgcolor: index % 2 === 0 ? "#f9f9f9" : "#ffffff", borderBottom: "1px solid #ddd", children: [_jsx(TeamSearchResultView, { teamSearchResult: teamSearchResult }), _jsx(Box, { sx: { flexGrow: 1 } }), teamSearchResult.canSubmitTransferRequest && (_jsx(TransferRequestButton, { team: { id: teamSearchResult.id } }))] }, teamSearchResult.id))), _jsx(Box, { display: "flex", justifyContent: "center", mt: 2, children: _jsx(Pagination, { showFirstButton: true, showLastButton: true, count: data.pageCount, page: page, onChange: handlePageChange }) })] }));
    };
    return (_jsxs(Container, { maxWidth: "md", style: { marginTop: "20px" }, children: [_jsx(ErrorSnackbar, { open: !!isError, message: "Failed to search for teams!" }), _jsx(Typography, { variant: "h4", gutterBottom: true, children: "Team Search" }), _jsxs("div", { style: { display: "flex", gap: "10px", marginBottom: "20px" }, children: [_jsx(TextField, { variant: "outlined", label: "Search teams", value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), fullWidth: true, onKeyDown: (e) => {
                            if (e.key === "Enter") {
                                handleSearch();
                            }
                        } }), _jsx(Button, { variant: "contained", color: "primary", onClick: handleSearch, children: "Search" })] }), renderResults()] }));
};
